export function SocialProofSection() {
  return (
    <section className="border-y border-white/5 bg-[#0A1628]/40" data-testid="social-proof-bar">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-10">
        <p className="text-center font-mono text-[11px] tracking-widest uppercase text-slate-500 mb-6">
          Trusted by conveyancing firms across England &amp; Wales
        </p>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
          {[
            { label: "GDPR Compliant", icon: ShieldCheck },
            { label: "SRA-friendly audit trail", icon: FileCheck },
            { label: "AES-256 Encrypted", icon: Lock },
            { label: "UK Hosted (AWS London)", icon: Server },
          ].map((b) => (
            <div key={b.label} className="flex items-center gap-2.5 justify-center md:justify-start" data-testid={`trust-${b.label}`}>
              <b.icon className="w-4 h-4" style={{ color: "#00D4AA" }} strokeWidth={1.8} />
              <span className="text-sm text-slate-300">{b.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
